import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Organisation } from "../../models/organisation.model";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { Campaign } from "../../models/campaign.model";
import { Utils } from "../../helper/utils.helper";

let OrganisationSettingsComponent = {
    selector: "vcOrganisationSettings",
    templateUrl:
        "/angular/components/organisation-settings/organisation-settings.component.html",
    bindings: {},
    controller: class OrganisationSettingsController {
        private activeOrganisation: Organisation;
        private activeCampaign: Campaign;
        private securitySettings: object = null;

        private $scope: any;
        private $location: any;
        private dialog: DialogUtils;
        private utils: Utils;

        private campaignDataProvider: CampaignDataProvider;
        private permissionProvider: PermissionCheck;
        private navigationBarService: NavigationBarHelperService;

        constructor(
            $scope: any,
            $location: any,
            CampaignDataProvider: CampaignDataProvider,
            PermissionCheck: PermissionCheck,
            DialogUtils: DialogUtils,
            Utils: Utils,
            NavigationBarHelperService: NavigationBarHelperService
        ) {
            this.$scope = $scope;
            this.$location = $location;
            this.dialog = DialogUtils;
            this.utils = Utils;
            this.navigationBarService = NavigationBarHelperService;

            this.campaignDataProvider = CampaignDataProvider;
            this.permissionProvider = PermissionCheck;

            this.campaignDataProvider
                .getOrganisations()
                .then((organisation: Organisation) => {
                    this.activeOrganisation = organisation;
                });
            this.activeCampaign = this.campaignDataProvider.getActiveCampaign();
            this.permissionProvider
                .getSecuritySettings()
                .then(
                    (securitySettings) =>
                        (this.securitySettings = securitySettings)
                );

            this.navigationBarService.setShowBackButton(true);
        }

        openUpdateLeader(organisation: Organisation, $event): void {
            this.dialog
                .show({
                    component: "vc-update-leader",
                    targetEvent: $event,
                    scope: this.$scope,
                    locals: {
                        leader: organisation,
                    },
                    ariaLabel: "Update Organization",
                })
                .then((updatedLeader) => {
                    angular.extend(organisation, updatedLeader);
                    angular.extend(
                        this.campaignDataProvider.activeOrganisation,
                        organisation
                    );
                });
        }

        openLicensesDialog(ev): void {
            this.dialog.show({
                component: "vc-organisation-user-licenses-dialog",
                targetEvent: ev,
                scope: this.$scope,
                locals: {
                    organisation: this.activeOrganisation,
                },
                size: "large",
                ariaLabel: "Export Data",
            });
        }

        createDivision($event: any): void {
            this.dialog.show({
                component: "vc-division-create-dialog",
                targetEvent: $event,
                scope: this.$scope,
                clickOutsideToClose: false,
                multiple: false,
                locals: {},
            });
        }

        showSecuritySettingsInfo($event): void {
            $event.stopPropagation();
            const openInfoModal = this.dialog
                .confirm()
                .htmlContent(
                    '<p style="max-width: 500px">' +
                        '<span class="bold">Two-factor authentication</span><br/>' +
                        "Two-factor authentication is an enhanced security measure. Once enabled, users will be required to give two types of identification when they log in to Ecanvasser.<br/><br/>" +
                        '<a href="https://support.ecanvasser.com/en/articles/4911238-set-up-two-factor-authentication-for-your-ecanvasser-login" class="md-primary" target="_blank">Learn more</a></p>'
                )
                .ok("OK");
            this.dialog.showPreConfiguredDialog(openInfoModal);
        }

        openUpdateUserURLText($event): void {
            this.dialog.show({
                component: "vc-update-user-url-text-dialog",
                targetEvent: $event,
                scope: this.$scope,
                locals: {},
                ariaLabel: "Update Organization",
            });
        }

        openViewPlanDetails(): void {
            this.$location.url("/leaderdetails");
        }
    },
};

angular
    .module("organisationSettings", [])
    .component(
        OrganisationSettingsComponent.selector,
        OrganisationSettingsComponent
    );
